Previgesst.xhr.abort = function () {};

(function ($) {
    if ($('#invite-to-organisation-container').length) {

        $('#organisation-users-list').on('click', '.open-member-detail', function (e) {
            e.preventDefault();
            var c = $('#member-details-container'), me = $(this),
                    url = new URL(document.getElementById('member-detail-link-view-formations').href);

            // assign content
            c.find('.member-detail-header').html(me.html());
            $('.autorize-formation', '#member-details-container').toggle($(this).parent().hasClass('requested'));

            url.searchParams.set('user_id', me.data('uid'));
            $('#member-detail-link-view-formations').prop('href', url.href);
            $('#member-detail-link-autorize-formation').prop('href', url.href);
            // show
            c.modal('show');

        });

        $('#member-details-container').on('click', '#member-detail-link-view-formations', function (e) {
            e.preventDefault();
        });

        $('#organisation-users-list').on('click', '.unset-from-organisation', function (e) {
            e.preventDefault();

            var uid = $(this).data('uid'),
                    s = $(this).data('s');

            Previgesst.confirm(
                    'Êtes-vous certain de vouloir supprimer cet utilisateur?',
                    'Confirmer la suppression',
                    function () {

                        Previgesst.xhr.abort();
                        Previgesst.xhr = $.post(
                                Previgesst.ajax,
                                {
                                    action: 'remove_user_from_organisation',
                                    uid: uid,
                                    s: s
                                },
                                function (r) {
                                    $('#generic-confirm-container').modal('hide');
                                    if (r.success) {
                                        Previgesst.alert(r.message, 'message');
                                        $('#user-id-' + uid).remove();
                                        if (0 === $('#organisation-users-list').children().length) {
                                            $('#organisation-users-list').addClass('hidden');
                                            $('#organisation-no-users').removeClass('hidden');
                                        }

                                    } else {
                                        Previgesst.alert(r.data[0].message, 'error');
                                    }
                                }
                        );
                    });
        });

        $('#user-organisation-name-edit').click(function (e) {
            e.preventDefault();
            $('#user-organisation-name').prop('disabled', false);
            $('#user-organisation-name-save').show();
            $(this).hide();
        });

        $('#user-organisation-name-save').click(function (e) {
            e.preventDefault();
            var name = $('#user-organisation-name').val(),
                    ori = $('#user-organisation-name').prop('placeholder'),
                    s = $('#user-organisation-name').data('s');

            if ('' === name) {
                name = ori;
                $('#user-organisation-name').val(ori);
            }

            if (ori === name) {
                $('#user-organisation-name').prop('disabled', true);
                $('#user-organisation-name-edit').show();
                $(this).hide();
                return;
            }
            // do save
            Previgesst.xhr.abort();
            Previgesst.xhr = $.post(
                    Previgesst.ajax,
                    {
                        action: 'save_user_organisation_name',
                        name: name,
                        s: s
                    },
                    function (r) {
                        if (r.success) {
                            Previgesst.alert(r.message, 'message');
                            $('#user-organisation-name').prop('placeholder', name);
                        } else {
                            Previgesst.alert(r.data[0].message, 'error');
                            $('#user-organisation-name').val(ori);
                        }
                        $('#user-organisation-name').prop('disabled', true);
                        $('#user-organisation-name-edit').show();
                        $('#user-organisation-name-save').hide();
                    }
            );
        });

        $('#invite-to-organisation').submit(function (e) {
            e.preventDefault();
            $('#invite-to-organisation').addClass('loading');
            Previgesst.xhr.abort();
            Previgesst.xhr = $.post(
                    Previgesst.ajax,
                    {
                        action: 'add_user_to_organisation',
                        s: Previgesst.organisation.security,
                        e: $('#invite-user-email').val(),
                        f: $('#invite-user-first-name').val(),
                        l: $('#invite-user-last-name').val()
                    },
                    function (r) {
                        $('#invite-to-organisation').removeClass('loading');
                        if (r.success) {
                            var m = r.message, c = 'message';
                            $('#organisation-users-list').prepend($(r.html));

                            $('#organisation-users-list').removeClass('hidden');
                            $('#organisation-no-users').addClass('hidden');


                        } else {
                            var m = r.data[0].message, c = 'error';
                        }
                        $('#invite-to-organisation-notice').text(m).addClass(c).fadeIn();
                        setTimeout(function () {
                            $('#invite-to-organisation-notice').fadeOut(function () {
                                $(this).text('').removeClass(c);
                            })
                        }, 3000);

                        $('#invite-user-email').val('');
                        $('#invite-user-first-name').val('');
                        $('#invite-user-last-name').val('');
                    }
            );
        });

    }
    $('.woocommerce-MyAccount-orders a').data('rel','popup')
    $('.woocommerce-MyAccount-orders a').on('click',function(e){
            
        if (!$(this).hasClass("pay")) {
            e.preventDefault();
            e.stopPropagation();
            var href = $(this).prop('href');
            $('.modal-body','#view-order').load(href + ' .woocommerce-MyAccount-content',function(e){$('#view-order-container').find('.buy-credits').remove();$('#view-order-container').modal('show');});
        }
        
    });
    $('.formation-list').on('click', '.formation-item.requested', function (e) {
        e.preventDefault();
        if ($('#admin-view').length) { 
            var me = $(this),
                uid = $('#admin-view').data('uid'),
                fid = $(this).data('fid'),
                s = $('#admin-view').data('s');
            Previgesst.confirm(
                    'Ce membre souhaite suivre cette formation. Souhaitez-vous confirmer l’attribution?',
                    'Approbation demandée',
                    function (e) {
                        e.preventDefault();
                        Previgesst.xhr.abort();
                        Previgesst.xhr = $.post(
                                Previgesst.ajax,
                                {
                                    action: 'approve_formations',
                                    s: Previgesst.formation.security,
                                    fid: fid,
                                    uid: uid
                                },
                                function(r){
                                    $('#generic-confirm-container').modal('hide');
                                    Previgesst.alert(r.message,'Succès');
                                    // change 
                                    me.removeClass('requested').addClass('progress-0');
                                    me.find('a').prop('title','Lancer la formation');
                                    me.find('.status-label').text('0%');
                                    for (var s in r.content){
                                        $(s).html(r.content[s]);
                                    }
                                });
                    }
            );
        } else {
            Previgesst.alert('Cette formation n’a pas encore été approuvé par votre administrateur.', 'Désolé');
        }
    })


})(jQuery);